import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { makeStyles } from "@material-ui/core/styles"

import { useDownloadStream, sizeConvert } from "Utils"
import Alert from "./alert.jsx"
import Loading from "../Loading"

function Download(props) {
  const { fileUid, onComplete } = props
  
  const fileMeta = useSelector(state => state.list.file[fileUid])

  const progress = useDownloadStream(fileUid)

  useEffect(() => {
    if(progress.status === "finished" && progress.blob && onComplete) {
      onComplete(progress.blob)
    }
  }, [progress.status, progress.blob, onComplete])

  const classes = styles()

  return (
    <Alert
      open={progress.status === "started"}
      title="File download"
      text={`${fileMeta.name}.${fileMeta.ext} (${sizeConvert(progress.total)})`}
      content={
        <Loading
          className={classes.loading}
          type="linear"
          determinate
          value={progress.percent}
          label={`${progress.percent}%`}
        />
      }
    />
  )
}

const styles = makeStyles(theme => ({
  loading: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    marginLeft: 35
  }
}))

export default Download